import { FetchBalladsResponse } from '@digimap/types/api'
import apiFetch from './apiFetch'

export default async function fetchBallads() {
  return await apiFetch<void, FetchBalladsResponse>('ballads')
}
